import { createContext } from "react";
/**
 * Controls maximum depth for the configuration
 *
 * This can save additional fetched for small configurations
 *
 * @category Settings
 */
export const ConfigurationMaxDepthContext = createContext(1);
ConfigurationMaxDepthContext.displayName = "ConfigurationMaxDepthContext";
//# sourceMappingURL=ConfigurationMaxDepthContext.js.map